import barba from "@barba/core";

// Simple unique ID generator
let idCounter = 0;
const uniqueId = () => {
  idCounter += 1;
  return `component-${idCounter}`;
};

/**
 * Observe the page to load or destroy component instances.
 */
export class ClientComponentManager {
  /**
   * @param {function|string} name - component class, or file handle for async loading.
   * @param {string} selector - selector to determine if page needs component.
   */
  constructor(name, selector) {
    this.name = name;
    this.selector = selector;
    this.instances = []; // Track component instances that will be destroyed.
    this.ComponentClass = null; // Class to create component instances from.
    this.loadedStateDataAttribute = `data-loaded-${uniqueId()}`;

    this.load = this.load.bind(this);
    this.destroyInstances = this.destroyInstances.bind(this);

    // Initial load
    this.load();

    // Barba hooks
    barba.hooks.after(() => this.load());
    barba.hooks.beforeLeave(() => this.destroyInstances());
  }

  async load() {
    const elements = document.querySelectorAll(
      `${this.selector}:not([${this.loadedStateDataAttribute}])`
    );

    if (elements.length === 0) {
      return;
    }

    if (!this.ComponentClass) {
      if (typeof this.name === "function" && this.name.prototype) {
        // It's already a class constructor
        this.ComponentClass = this.name;
      } else if (typeof this.name === "function") {
        // It's a dynamic import function
        const module = await this.name();
        // The actual class can be the default export, or the module itself
        this.ComponentClass = module.default || module;
      } else {
        // Fallback for non-class, non-function `name` (though not expected)
        this.ComponentClass = this.name;
      }
    }

    elements.forEach((element) => {
      element.setAttribute(this.loadedStateDataAttribute, "true");
      const instance = new this.ComponentClass(element);
      this.instances.push(instance);
    });
  }

  destroyInstances() {
    this.instances.forEach((instance) => {
      if (typeof instance.disconnect === "function") {
        instance.disconnect();
      }
    });
    this.instances = [];
  }
} 